import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";

import UserDataService from "../../services/user-data-service/UserDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UserImageQueryParameters = {
    userID: number
} & BaseUseQueryParameters<string | undefined>

export function useUserImage(params: UserImageQueryParameters) {
    return useQuery<string | undefined, RestError>(
        keys.image(params.userID),
        ({ signal }) => {
            return UserDataService.getUserImage(params.userID, signal);
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds  * 1000 : false
        }
    );
}
